import { render, staticRenderFns } from "./CriminalConvictions.vue?vue&type=template&id=c1d3d58c&"
import script from "./CriminalConvictions.vue?vue&type=script&lang=js&"
export * from "./CriminalConvictions.vue?vue&type=script&lang=js&"
import style0 from "./CriminalConvictions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
